
import {
    SET_NOTIFICATIONS,
    SET_IN_APP_NOTIFICATIONS,
} from './types';

import { apiCallV2 } from "../../utils/api";

export const GetNotifications = (page, count, filter, sort) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "push-notification/get",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            count: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res.status == 200) {
        dispatch({
            type: SET_NOTIFICATIONS,
            data: {
                list: res.data.notifications,
                count: res.data.count[0]["count(*)"]
            }
        })
    }
}

export const GetInAppNotifications = (page, count, filter, sort) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "in-app-notification/get-all-v2",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res.status == 200) {
        dispatch({
            type: SET_IN_APP_NOTIFICATIONS,
            data: {
                list: res.data.inAppNotifications,
                count: res.data.count[0]["count(*)"]
            }
        })
    }

}


